// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hv1e","label":"styles_label__TW3BI"};